module.exports = __webpack_public_path__ + "static/img/140.4fca29c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/140.png
// module id = qEsP
// module chunks = 0